module.exports = __webpack_public_path__ + "development-speed.o1besz8l.svg";